import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import { useMediaQuery } from "@mui/material";

import SearchIcon from "../icons/SearchIcon";
import ChatIcon from "../icons/ChatIcon";
import UserPlus from "../icons/UserPlus";
import HelpIcon from "../icons/HelpIcon";

import LargeScreen from "./LargeScreenAppHeaderToolbar";
import SmallScreen from "./SmallScreenAppHeaderToolbar";
import theme from "../themes/baseTheme";
import { getGlobalClientId, getOrgType, removeUserSession } from "../utils/Token";
import axios from "../utils/fvAxios";
import apiinfo from "../utils/base-uri.json";
import {
  setToken,
  setEmail,
  setUserName,
  setGlobalClientId,
  setstatuses,
  setOrgType as setOrgTypeLocalStorage,
  setLocalMenus,
  removeIncognitoEmail
} from "../utils/Token";

const settings = [
  // { id: "profile", text: "Profile", onClick: () => {} },
  // { id: "account", text: "Account", onClick: () => {} },
  // { id: "dashboard", text: "Dashboard", onClick: () => {} },
  {
    id: "logout",
    text: "Logout",
    onClick: () => {      
      //sessionStorage.removeItem("session");
      removeUserSession();
      window.location = "/";
      const channel = new BroadcastChannel("refresh_channel");
      channel.postMessage('refresh3');

    },
  },
];


const icons = [ChatIcon];

export default function AppHeader(props) {
  const largeScreen = useMediaQuery(theme.breakpoints.up("sm"));
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const [clients, setClients] = useState([]);
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleSubMenuClick = (index) => {

    setAnchorElNav(null);
    if (icons[index] === ChatIcon) {
      props.handleWidgetDrawer();
    }
  };

  const switchToIncognitoUser = () => {
    axios.post(apiinfo.Users.IncognitoUser).then((response) => {
      if (response?.data?.responseCode >= 0) {
        setToken(response?.data?.data?.token);
        setUserName(response?.data?.data?.userName);
        setEmail(response?.data?.data?.email);

        setGlobalClientId(response?.data?.data?.globalClientIds);
        setOrgTypeLocalStorage(response?.data?.data?.orgType);
        setLocalMenus(response?.data?.data?.userMenus);

        axios.get(apiinfo.dashboard.GetprequalificationStatuses).then((res) => {
          if (res?.data?.status === true) {
            setstatuses(res?.data?.data);
          } else {
            alert(res.data.responseMessage);
          }
        });
        removeIncognitoEmail();

        const channel = new BroadcastChannel('refresh_channel');
        channel.postMessage('refresh');

        window.location = "/DashBoard";
      } else {
        window.location = "/DashBoard";
      }
    });
  };

  return (
    <AppBar position="static">
      <Container
        maxWidth="false"
        sx={{ "@media (min-width: 600px)": { paddingLeft: "12px" } }}
      >
        {largeScreen ? (
          <LargeScreen
            icons={icons}
            selectOptions={clients}
            userSettings={settings}
            handleOpenUserMenu={handleOpenUserMenu}
            handleCloseUserMenu={handleCloseUserMenu}
            anchorElUser={anchorElUser}
            handleSubMenuClick={handleSubMenuClick}
            switchToIncognitoUser={switchToIncognitoUser}
          />
        ) : (
          <SmallScreen
            icons={icons}
            userSettings={settings}
            handleOpenNavMenu={handleOpenNavMenu}
            handleCloseNavMenu={handleCloseNavMenu}
            handleOpenUserMenu={handleOpenUserMenu}
            handleCloseUserMenu={handleCloseUserMenu}
            anchorElUser={anchorElUser}
            anchorElNav={anchorElNav}
            handleSubMenuClick={handleSubMenuClick}
            switchToIncognitoUser={switchToIncognitoUser}
          />
        )}
      </Container>
    </AppBar>
  );
}
